import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface SpecificFilterTypeConfig {
  type: string;
  options?: {
    [name: string]: any;
  };
}

@Injectable({
  providedIn: 'root',
})
export class SpecificFilterBarService {
  private _specificFilterBar: Subject<SpecificFilterTypeConfig> = new Subject<SpecificFilterTypeConfig>();

  constructor() {
    this._specificFilterBar.next(null);
  }

  toggleFilterBar(specificFilterTypeConfig: SpecificFilterTypeConfig) {
    this._specificFilterBar.next(specificFilterTypeConfig);
  }

  get isSpecificFilterBarOpened(): Observable<SpecificFilterTypeConfig> {
    return this._specificFilterBar;
  }
}

